module.exports = __webpack_public_path__ + "img/left_layout.f711f001.svg";